/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergedUserSelfUpdateSettings
 */
export interface MergedUserSelfUpdateSettings {
    /**
     * 
     * @type {boolean}
     * @memberof MergedUserSelfUpdateSettings
     */
    arc_flash_detection_on?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MergedUserSelfUpdateSettings
     */
    fall_detection_on?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MergedUserSelfUpdateSettings
     */
    head_impact_detection_on?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MergedUserSelfUpdateSettings
     */
    mute_sos_button?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MergedUserSelfUpdateSettings
     */
    already_accepted_spec_etag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MergedUserSelfUpdateSettings
     */
    already_accepted_pvd_etag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MergedUserSelfUpdateSettings
     */
    already_accepted_emergency_etag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MergedUserSelfUpdateSettings
     */
    language_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MergedUserSelfUpdateSettings
     */
    org_user_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof MergedUserSelfUpdateSettings
     */
    user_private_settings_azure_id: string;
}

/**
 * Check if a given object implements the MergedUserSelfUpdateSettings interface.
 */
export function instanceOfMergedUserSelfUpdateSettings(value: object): value is MergedUserSelfUpdateSettings {
    if (!('org_user_azure_id' in value) || value['org_user_azure_id'] === undefined) return false;
    if (!('user_private_settings_azure_id' in value) || value['user_private_settings_azure_id'] === undefined) return false;
    return true;
}

export function MergedUserSelfUpdateSettingsFromJSON(json: any): MergedUserSelfUpdateSettings {
    return MergedUserSelfUpdateSettingsFromJSONTyped(json, false);
}

export function MergedUserSelfUpdateSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergedUserSelfUpdateSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'arc_flash_detection_on': json['arc_flash_detection_on'] == null ? undefined : json['arc_flash_detection_on'],
        'fall_detection_on': json['fall_detection_on'] == null ? undefined : json['fall_detection_on'],
        'head_impact_detection_on': json['head_impact_detection_on'] == null ? undefined : json['head_impact_detection_on'],
        'mute_sos_button': json['mute_sos_button'] == null ? undefined : json['mute_sos_button'],
        'already_accepted_spec_etag': json['already_accepted_spec_etag'] == null ? undefined : json['already_accepted_spec_etag'],
        'already_accepted_pvd_etag': json['already_accepted_pvd_etag'] == null ? undefined : json['already_accepted_pvd_etag'],
        'already_accepted_emergency_etag': json['already_accepted_emergency_etag'] == null ? undefined : json['already_accepted_emergency_etag'],
        'language_code': json['language_code'] == null ? undefined : json['language_code'],
        'org_user_azure_id': json['org_user_azure_id'],
        'user_private_settings_azure_id': json['user_private_settings_azure_id'],
    };
}

export function MergedUserSelfUpdateSettingsToJSON(json: any): MergedUserSelfUpdateSettings {
    return MergedUserSelfUpdateSettingsToJSONTyped(json, false);
}

export function MergedUserSelfUpdateSettingsToJSONTyped(value?: MergedUserSelfUpdateSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'arc_flash_detection_on': value['arc_flash_detection_on'],
        'fall_detection_on': value['fall_detection_on'],
        'head_impact_detection_on': value['head_impact_detection_on'],
        'mute_sos_button': value['mute_sos_button'],
        'already_accepted_spec_etag': value['already_accepted_spec_etag'],
        'already_accepted_pvd_etag': value['already_accepted_pvd_etag'],
        'already_accepted_emergency_etag': value['already_accepted_emergency_etag'],
        'language_code': value['language_code'],
        'org_user_azure_id': value['org_user_azure_id'],
        'user_private_settings_azure_id': value['user_private_settings_azure_id'],
    };
}

